var React = require('react');

function Check1 (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_4276","data-name":"Ellipse 4276","cx":"8","cy":"8","r":"8","fill":"#bdff3b","key":0}),React.createElement("path",{"id":"Path_104348","data-name":"Path 104348","d":"M-13942.449,2480l2.257,2.255,4.352-4.352","transform":"translate(13947.146 -2472.08)","fill":"none","stroke":"#000","strokeWidth":"1.5","key":1})]);
}

Check1.defaultProps = {"id":"check1","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Check1;

Check1.default = Check1;
